import { render, staticRenderFns } from "./display-form.vue?vue&type=template&id=9f6f474c&scoped=true&"
import script from "./display-form.ts?vue&type=script&lang=ts&"
export * from "./display-form.ts?vue&type=script&lang=ts&"
import style0 from "./display-form.scss?vue&type=style&index=0&id=9f6f474c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6f474c",
  null
  
)

export default component.exports